<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 24 24"
  width="24"
  height="24"
>
    <ng-container *ngIf="Circle">
        <circle cx="50%" cy="50%" r="50%" class="fill_main_color" />
    </ng-container>
    <path
        class="fill_white"
        d="M16.5,10.5h-3v-3a1.5,1.5,0,0,0-3,0v3h-3a1.5,1.5,0,0,0,0,3h3v3a1.5,1.5,0,0,0,3,0v-3h3a1.5,1.5,0,0,0,0-3Z"
    />
</svg>
